import { defineComponent, ref } from 'vue';
export default defineComponent({
  name: 'SearchSelect',
  props: {
    value: {
      type: String
    },
    placeholder: {
      type: String
    },
    size: {
      type: String,
      default: 'large'
    },
    options: {
      type: Array,
      default: []
    }
  },
  setup: function (_, _a) {
    var emit = _a.emit;
    var onSearchTextChange = function (e) {
      emit('search', e.target.value);
      emit('update:value', e.target.value);
    };
    var onItemSelect = function (item) {
      current.value = [item.key];
      emit('select', item.key);
    };
    var current = ref([]);
    return {
      onSearchTextChange: onSearchTextChange,
      onItemSelect: onItemSelect,
      current: current
    };
  }
});